import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';

declare let $: any;
@Component({
  selector: 'tangram-pathway-detail',
  templateUrl: './pathway-detail.component.html',
  styleUrls: ['./pathway-detail.component.scss']
})
export class PathwayDetailComponent implements OnInit, OnChanges {
  @Input() pathwayDetail: any;
  @Input() isDashboard: boolean;
  iconPath = appConfig.iconPath;
  @Input() isEmbedded: boolean = false;
  @Input() compactView: boolean = false;
  constructor() { }
  
  ngOnInit() {
  }

  ngOnChanges(_changes: SimpleChanges) {
    // if (changes['pathwayDetail']) {
    // }
  }

  /**
   * Show video description modal
   */
  showVideoDescriptionModal() {
    $("#videoDescriptionModal").appendTo('body').modal('show');
  }

}
